
import { PropType, defineComponent } from 'vue';
import ConfirmationOverlay from './ConfirmationOverlay.vue';
import { useWindowSize } from '@vueuse/core';

export default defineComponent({
    name: 'AttachTrailerConfirmation',
    components: {
        ConfirmationOverlay,
    },
    emits: ['accept', 'reject'],
    props: {
        trailerNumber: {
            type: String as PropType<string | undefined>,
            required: true,
        },
        trailerCompany: {
            type: String as PropType<string | undefined>,
            required: true,
        },
    },
    setup() {
        const { width } = useWindowSize();

        return {
            width,
        };
    },
    computed: {
        isFullScreen() {
            return this.width < 1200;
        },
    },
});
